import { render, staticRenderFns } from "./communicationsSender.vue?vue&type=template&id=f2910498&"
import script from "./communicationsSender.vue?vue&type=script&lang=js&"
export * from "./communicationsSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports